module.exports = __webpack_public_path__ + "static/media/FACURRYC_MENU-normal.876bf7a8.png";